export var config = {
    serviceUri: "https://us-central1-cepi-eng.cloudfunctions.net/"
}